/**
 * 案件アサイン履歴の契約（path・レコード型・役割）。
 *
 * 全体PJ看板の「案件をアサインする」が成功した行を、product-api が 1 件ずつ履歴として残す。
 * それを読む PI Lab の画面と mcp-project-management が**同じ型と path を引く**ために、
 * サービス間契約と同じこのパッケージに置く（`apps/` 間の直接 import は不可）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件アサイン履歴の一覧・アサイン意図の保存で product-api / Web / MCP が共有する path と型
 * @graph-connects none
 */
/** アサイン履歴の一覧 path（GET）。 @graph-connects none */
export const ASSIGNMENT_HISTORY_PATH = '/projects/assignment-history';
/**
 * アサイン意図の保存 path（PUT）。
 * @graph-connects none
 */
export function assignmentHistoryIntentPath(id) {
    return `${ASSIGNMENT_HISTORY_PATH}/${encodeURIComponent(id)}/intent`;
}
/**
 * アサイン意図の最大文字数。判定は product-api だけが行い、画面と MCP は API の
 * エラーメッセージをそのまま見せる（入口に上限を写すと、変えたときに黙ってずれる）。
 * @graph-connects none
 */
export const ASSIGNMENT_INTENT_MAX_LENGTH = 2000;
/**
 * 一覧をチームで絞り込むときのクエリパラメータ名（値は KPI のチーム。例: `growth`）。
 * @graph-connects none
 */
export const ASSIGNMENT_HISTORY_TEAM_PARAM = 'team';
/**
 * 履歴 1 件の要件定義開発者・開発者・レビュワーのうち、誰か 1 人でも `team` に当たるか。
 *
 * 画面（手元で絞る）と product-api（`?team=` で絞る）が同じ判定を使うためにここへ置く。
 * @graph-connects none
 */
export function assignmentHistoryEntryMatchesTeam(entry, memberTeams, team) {
    return [entry.requirementEngineer, entry.developer, entry.reviewer].some((name) => name !== null && (memberTeams[name.toLowerCase()] ?? []).includes(team));
}
//# sourceMappingURL=assignment-history.js.map